// Urls

export const BaseUrl = process.env.REACT_APP_API_BASE_URL as string;

export const API_URL = BaseUrl + '/api/v1';

// Token Url
export const TokenUrl = API_URL + '/get-jwt-token';

// Setting Url
export const SettingsUrl = API_URL + '/settings';

// Landing Page Url
export const LandingPageUrl = API_URL + '/home';

// Contact Us Url
export const ContactUsUrl = API_URL + '/contact-us';

// Styles
export const CategoriesUrl = API_URL + '/get-category';
export const GetCategoriesesBySlugUrl = (slug: string, pageNo: number = 1) =>
  CategoriesUrl + `/${slug}/${pageNo}`;

// Styles
export const StylesUrl = API_URL + '/get-style';
export const GetStyleProductUrl = (
  id: number,
  pageNo: number = 1,
  search: string = ''
) => StylesUrl + `/${id}/${pageNo}/${search}`;

// Product Details

export const ProductsUrl = API_URL + '/products';
export const GetProductDetailsUrl = (id: number) =>
  ProductsUrl + '/get-product/' + id;
export const GetManageColorsUrl = ProductsUrl + '/colors';

// Resources
export const ResourcesUrl = API_URL + '/resources';
export const PdfUrl = API_URL + '/pdf';
export const GetResourcesUrl = ResourcesUrl;

// Why Vista Mark

export const GetWhyVistaMarkUrl = API_URL + '/why-vista-mark';

// DigitalShowroom
export const DigitalShowroomUrl = API_URL + '/digital-showroom';
export const GetDigitalShowroom = DigitalShowroomUrl + '/';
export const GetDigitalShowroomProducts = ({
  styleId,
  search,
}: {
  styleId: number;
  search: string;
}) => DigitalShowroomUrl + `/get-style-products-data/${styleId}/${search}`;

// Warranty Url
export const WarrantyUrl = API_URL + '/register-warranty';

// Careers Url
export const CareerUrl = API_URL + '/career-submission';

// Privacy Policy Page Url
export const PrivacyPolicyPageUrl = API_URL + '/privacy-policy';

// Fly Page Details

export const FlyPageUrl = API_URL + '/fly-pages';
export const GetFlyPageByIdUrl = (id: number) => FlyPageUrl + '/get/' + id;
